import { Effect } from 'effect';

import { getProductsByTaxon } from '../../bind/product';
import { RuntimeClientAtom } from '@vs-shop/engine/runtime/RuntimeClient';
import * as Atom from 'effect/unstable/reactivity/Atom';
import { tagged } from '@vs-shop/engine/data/util/tagged';

// Define a Data.tagged type for type-safe atom keys with Equal implementation
type FetchHomepageProductsKey = {
  readonly _tag: 'FetchHomepageProductsKey';
  readonly taxonCode: string;
  readonly page: number;
  readonly itemsPerPage: number;
};

const FetchHomepageProductsKey = tagged<FetchHomepageProductsKey>('FetchHomepageProductsKey');

const fetchHomepageProductsAtomFamily = Atom.family((key: FetchHomepageProductsKey) => {
  return RuntimeClientAtom.atom(
    Effect.gen(function* () {
      const { taxonCode, page, itemsPerPage } = key;

      return yield* getProductsByTaxon({
        taxonCode,
        page,
        itemsPerPage,
      });
    })
  ).pipe(Atom.keepAlive);
});

export const fetchHomepageProductsPageAtom = (
  taxonCode: string,
  page: number,
  itemsPerPage: number
) => {
  const key = FetchHomepageProductsKey({ taxonCode, page, itemsPerPage });

  return fetchHomepageProductsAtomFamily(key);
};
